// Shows a card with a heading, subheading, count of items in an array of Tasks, a variable number of tasks and then a link to show all if there are more
// to show. You can set an icon to show and color to use.
//
// prop.heading is the heading for the Task Summary.
// prop.subheading is the sub-heading for the Task Summary.
// props.icon is the FontAwesome glyph to show (e.g. "fa-exclamation-circle")
// props.color is the color to use (e.g. "text-danger")
// props.bucket is the bucket showing summary (see utilties/TaskBuckets for fields -- like name, icon, color, numTasksToShow, [tasks], taskUrl).
// props.onClickTask is a function called when click on a task. Receives (task, tasksListBucket)
// where tasksListBucket is bucket.tasksUrl ('overdue' | 'soon' | 'all') for return navigation after delete.
// props.numTasksToShow is # of tasks to show (and then a "see all")
// props.setShowTaskBucket is a function that takes a bool to show a bucket of tasks, from setTaskBucket
// props.setTaskBucket is a function that sets the task bucket setShowTasksList shows.

import Button from 'react-bootstrap/Button';

// Map each bucket's accent class to the matching RGB token so the card gets the
// same per-bucket background wash the all-items page uses (overdue → danger,
// soon → warning). The "All Tasks" bucket (text-primary) deliberately falls
// through to the neutral body-color tint to mirror the all-items total row,
// which is neutral rather than indigo. The tokens flip per theme in tokens.css,
// so the rgba() washes (see .task-bucket-card in App.css) adapt to light/dark.
const TINT_RGB_BY_COLOR = {
  'text-danger': 'var(--bs-danger-rgb)',
  'text-warning': 'var(--bs-warning-rgb)',
};

function TaskSummary(props) {
  const tintRgb = TINT_RGB_BY_COLOR[props.color] || 'var(--bs-body-color-rgb)';
  // Ask the parent to show all our tasks.
  function onClickSeeAll() {
    props.setTaskBucket(props.bucket);
    props.setShowTaskBucket(true);
  }

  const singleTask = (task) => {
    return (
      <tr key={task.id} onClick={() => props.onClickTask(task, props.bucket.tasksUrl)}>
        <td className="text-break">
          <div className="entered-data">
            {task.name}
          </div>
        </td>
      </tr> 
    );
  }

  const taskLine = (task, index) => {
    if (index < props.numTasksToShow) {
      return singleTask(task);
    } else if (index === props.numTasksToShow) {
      return (
        <tr key='seeAllButtonId'>
          <td className="text-center">
            <Button variant="primary" size="sm" onClick={onClickSeeAll}>
              See All
            </Button>
          </td>
        </tr>
      );
    }

    return null;
  }

  const taskList = () => {
    if (props.bucket.tasks === null) {
      return <tr key='noneTextId'><td>"None"</td></tr>;
    }

    return props.bucket.tasks.map( (task, index) => { 
      return taskLine(task, index);
    });
  }

  return (
    <div className="col-md-4 col-12 mb-0" style={{ minWidth: 0 }}>
      <div className="card overflow-hidden task-bucket-card" style={{ '--tint-rgb': tintRgb }}>
        <div className="card-body">
          <div className="d-flex justify-content-between px-md-1">
            <div className="align-self-center">
              <i className={"fas fa-3x " + props.icon + " " + props.color}></i>
            </div>
            <div className="text-end" onClick={onClickSeeAll}>
              <h5 className={`${props.color || ''} fw-bold`.trim()}>{props.heading}</h5>
              <p>{ (props.bucket.tasks !== null) ? (props.bucket.tasks.length + " task" + (props.bucket.tasks.length > 1 ? "s" : "")) : "Loading..." }</p>
            </div>
          </div>
        </div>

        <div>
          <table className="table table-hover table-striped w-100 mb-0" style={{ tableLayout: 'fixed' }}>
            <tbody>
              { taskList() }
            </tbody>
          </table>
        </div>

      </div>
    </div>
  )
}

export default TaskSummary;
